import { api } from '@/api/query';

export function SessionHandler() {
  api.auth.query.useGetSession();

  return null;
}
